var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`frame-18`, _vm.className || ``]},[_c('img',{staticClass:"rectangle-93",attrs:{"src":_vm.rectangle,"alt":"Rectangle 93"}}),_c('p',{staticClass:"for-a-small-addition-1 heebo-normal-granite-gray-12px"},[_vm._v(" "+_vm._s(_vm.addition)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }